Bingo.PlaceAutocomplete = {};

Bingo.PlaceAutocomplete.init = function (locationSelector, coordinatesSelector, buttonSelector) {
    const input = document.getElementById(locationSelector);
    const coordinates = document.getElementById(coordinatesSelector);
    const button = document.getElementById(buttonSelector);
    const searchBox = new google.maps.places.SearchBox(input);

    google.maps.event.addListener(searchBox, 'places_changed', () => {
        const places = searchBox.getPlaces();
        if (places.length === 0) {
            return;
        }
        const place = places[0];

        if (!place.geometry) {
            return;
        }

        coordinates.value = Bingo.Map.packCoordinates(place.geometry.location.lat(), place.geometry.location.lng());
        input.value = place.formatted_address;
        coordinates.setAttribute('data-location', place.formatted_address);
        $(button).click();
    });

    google.maps.event.addDomListener(input, 'keydown', (e) => {
        if (e.keyCode === 13 && input.getAttribute('data-required') === 'true' && (coordinates.getAttribute('data-location') !== input.value || input.value === '' || coordinates.value === '')) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    $(button).click((e) => {
        if (input.getAttribute('data-required') === 'true' && (coordinates.getAttribute('data-location') !== input.value || input.value === '' || coordinates.value === '')) {
            e.preventDefault();
            e.stopPropagation();
            input.focus();
        }
    });

    google.maps.event.addDomListener(input, 'input', () => {
        if (!input.value) {
            coordinates.value = '';
        }
    });
};
